import "core-js/modules/es6.object.assign";

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}
/*
Copyright (c) 2018-2019 Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/
// BASEUI-GENERATED-FLAG-COMPONENT
// DO NOT EDIT THIS FILE DIRECTLY


import * as React from 'react';
export default function FlagEE(props) {
  return React.createElement("img", _extends({
    src: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD8AAAAtBAMAAADrb658AAAABGdBTUEAALGPC/xhBQAAAAFzUkdCAK7OHOkAAAAeUExURfz8/PT09BEREVKd5Vmk7RkZGUuV3iAgICQkJCYmJq3rrjoAAAEVSURBVDjL1YyxasQwDIblN7DfoASyHyR4Pmgf4DCYrIWA51tCbuzWZOuYvG1/yfElBxdfh6OlH7b0S/olestzpL83HKjKc6S6rqvXeo/q4YUfGGyeA7VtCMGGNlgrKtbWLt13khJdrpIJU15AaMWQ4xmGeZoGMI7jNM/DhIQ/Sxd5+qIhzwf1ec7UXy7959rYVqxh6Jvd9YYvdFsa4CUK6JzJ+8YnRHVrDU7k79E9MmwvOIal27KMnTtRWRZ4gEXhOJSxIc0XQpChE5FSuVCwIcszDP8CreTR+hE0iSaFSmmtAEf+BolLZGUMaWxIpbUx6BnkqHRUMBiZs9Q8jheuLgNDhA9KTjXvcEqGW9RV7RjMrxq+AYEyNRq9P9ddAAAAAElFTkSuQmCC",
    alt: "EE"
  }, props));
}